module.exports = __webpack_public_path__ + "img/scroll.657d1645.svg";